'use strict';

exports.__esModule = true;
exports.default = {
    common: {
        NOT_SET: '(not set)'
    },
    enhancedEcommerce: {
        CATEGORY_NAME: 'Enhanced Ecommerce',
        purchase: {
            STANDARD_MENU: 'Standard Menu',
            COMBO: 'Combo',
            ALACARTE: 'A la carte',
            DEFAULT_CURRENCY: 'USD'
        },
        checkoutOptionsMap: {
            STORED_CC: 'Saved Credit Card',
            ONETIME_CC: 'Unsaved Credit Card',
            ACCOUNT: 'Digital Account',
            CASH: 'Cash',
            NONE: 'Zero Dollar'
        }
    },
    events: {
        offerRedemption: {
            DATALAYER_EVENT_NAME: 'offerRedemption',
            OFFER_REDEMPTION: 'Offer Redemption',
            DIGITAL: 'Digital',
            MANUAL: 'Manual'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/providers/googleTagManager/constants.js
// module id = 93
// module chunks = 0